<template>
  <RadioGroup
  v-model="info.defaultValue"
  :type="info.form.formType==='button'?'button':undefined"
  :size="size">
    <Radio
      :label="item.value"
      v-for="item in info.form.options.staticList"
      :key="item.value"
      :disabled="info.form.disabled||!info.isNew">
      {{item.label}}
    </Radio>
  </RadioGroup>
</template>
<script>
import { baseComponentMixins } from '../mixins'

export default {
  name: 'BaseRadio',
  mixins: [ baseComponentMixins ],
}
</script>